/**
 * 在线聊天模块 key
 */
export default {
    /* 聊天 start */
    // 聊天-关键词搜索
    C_S_K: '搜索客户', // 采集时机：触发搜索，点击确定按钮或者筛选框失焦
    C_S_K_P: '手机搜索',
    C_S_K_E: '邮箱搜索',
    // 聊天-会话筛选（渠道相关）
    C_S_F: '会话列表筛选',
    C_S_F_T_0: '全部',
    C_S_F_T_1: '未读',
    C_S_F_T_2: '未回',
    C_S_F_T_3: '单聊',
    C_S_F_T_4: '群组',
    C_S_F_T_5: '免打扰',
    C_S_F_C: '社媒渠道筛选', // 采集时机：点击任意社媒渠道筛选
    C_S_F_S_0: '按最新排序',
    C_S_F_S_1: '按最旧排序',
    // 聊天-更多筛选
    C_S_F_M: '更多筛选',
    C_S_F_M_0: '访客标签',
    C_S_F_M_1: '手机号',
    C_S_F_M_2: '邮箱',
    C_S_F_M_3: '最后回复时间',
    C_S_F_M_4: '会话生成时间',
    // 聊天-发起新会话
    C_S_N_S: '发起新会话',
    C_S_N_S_B: '生成会话', // 确定按钮
    // 聊天-列表配置
    C_S_L_C: '列表配置',
    // 聊天-会话列表-已分配列表-成员筛选
    C_S_A_T: '成员选择',
    C_S_A_T_1: '成员筛选',
    C_S_A_T_2: '分组筛选',
    // 聊天-会话列表-已分配列表-活跃/历史会话
    C_S_S_0: '活跃会话',
    C_S_S_1: '历史会话',
    // 聊天-会话列表-未分配
    C_S_U: '未分配',
    // 聊天-会话列表-机器人
    C_S_R: '机器人',
    C_S_A_O: '会话列表操作',
    // 聊天-会话列表-会话操作（单个）
    C_S_A_S_0: '标为未读',
    C_S_A_S_1: '标为已读',
    C_S_A_S_2: '消息免打扰',
    C_S_A_S_3: '取消免打扰',
    C_S_A_S_4: '置顶会话',
    C_S_A_S_5: '取消置顶',
    C_S_A_S_6: '添加访客标签',
    // 聊天-会话列表-会话操作（批量）
    C_S_A_B: '批量选择',
    C_S_A_B_0: '批量_分配客服',
    C_S_A_B_1: '批量_重新分配',
    C_S_A_B_2: '批量_结束会话',
    C_S_A_B_3: '批量_未读/已读',
    C_S_A_B_4: '批量_切换托管',
    C_S_A_B_5: '批量_免打扰',
    C_S_A_B_6: '批量_加入黑名单',
    C_S_A_B_7: '批量_添加访客标签',
    // 聊天-视图查看
    C_S_V: '视图查看', // 点击任意视图
    C_S_V_S: '收起视图设置', // 采集时机：hover 鼠标悬浮，触发菜单
    C_S_V_S_0: '收起为侧边展示',
    C_S_V_S_1: '收起为图标展示',
    C_S_V_H: '收起视图', // 采集时机：点击收起视图
    C_S_V_C: '创建视图',
    C_S_V_C_S: '成功创建视图', // 点击创建弹窗创建按钮
    // 聊天-对话窗口
    C_S_C: '对话窗口', // 采集时机：点击会话item，进入会话窗口
    // 聊天-对话窗口-顶部栏
    C_S_C_T_0: '机器人托管', // 托管开关
    C_S_C_T_1: '会话标签',
    C_S_C_T_2: '搜索聊天消息',
    C_S_C_T_3: '结束会话',
    C_S_C_T_T_S: '翻译设置',
    C_S_C_T_T_0: '聊天翻译', // 特殊属性：addition: {  state: '1/0' } （旧翻译组件开关，已废弃）
    C_S_C_T_T_5: '聊天翻译开关', // 特殊属性：addition: {  state: '1/0' }
    C_S_C_T_T_1: '翻译预览', // 特殊属性：addition: {  state: '1/0' }
    C_S_C_T_T_3: '发送翻译', // 特殊属性：addition: {  state: '1/0' }
    C_S_C_T_T_4: '接收翻译', // 特殊属性：addition: {  state: '1/0' }
    // 聊天-对话窗口-消息体操作
    C_S_M_0: '消息撤回',
    C_S_M_1: '消息群聊艾特',
    C_S_M_2: '消息群聊私信',
    C_S_M_3: '消息推荐答案',
    C_S_M_4: '消息添加FAQ',
    C_S_M_5: '消息翻译',
    C_S_M_6: '消息识别访客语言',
    C_S_M_7: '消息回复',
    C_S_M_8: '消息引用',
    C_S_M_9: '消息添加话术',
    C_S_M_10: '语音转文本',
    C_S_M_10_0: '语音转文本_翻译',
    C_S_M_10_1: '语音转文本_收起文本',
    C_S_M_11: '添加至备注',
    C_S_M_12: '消息回复表情',
    C_S_M_13: '消息引用定位',
    C_S_M_14: '消息删除', // 采集时机：撤回对方消息
    C_S_M_15: '群聊查看成员',
    C_S_M_15_0: '群聊查看成员_发起私聊',
    C_S_M_16: '置顶消息',
    C_S_M_16_0: '置顶消息_确定置顶',
    C_S_M_17: '取消置顶消息',
    C_S_M_18: '查看置顶消息',
    C_S_M_19: '复制留资信息', // 聊天插件专有功能
    C_S_M_20: '桌面端下载图片', // 桌面端专有功能
    C_S_M_21: '快捷添加贴纸表情', // 消息操作：“添加我的收藏”
    C_S_M_22: '图片提取文本',
    C_S_M_23: '智能回复',
    // 聊天-输入联想
    C_S_C_L_0: '输入联想_发送',
    C_S_C_L_1: '输入联想_翻译并发送',
    // 聊天-发送区-按钮
    C_S_C_B_0: '快捷回复', // 采集时机：点击快捷回复
    C_S_C_B_0_0: '自动化流程',
    C_S_C_B_0_0_0: '自动化流程_选用', // 特殊属性：addition：{ id: '1', // 自动化流程id }
    C_S_C_B_0_0_1: '自动化流程_自动化管理',
    C_S_C_B_0_0_2: '自动化流程_搜索', // 采集时机：搜索
    C_S_C_B_0_1: '快捷回复_话术库',
    C_S_C_B_0_1_0: '快捷回复_话术库_发送',
    C_S_C_B_0_1_1: '快捷回复_话术库_翻译并发送',
    C_S_C_B_0_1_2: '快捷回复_话术库_点击话术编辑',
    C_S_C_B_0_1_3: '快捷回复_话术库_点击选择',
    C_S_C_B_1: '推荐商品',
    C_S_C_B_1_S: '推荐商品_发送',
    C_S_C_B_2: '邀请评价',
    C_S_C_B_2_S: '邀请评价_确定',
    C_S_C_B_3: '快捷艾特成员',
    C_S_C_B_3_0: '快捷艾特成员_选择成员',
    C_S_C_B_4: '图文发送',
    C_S_C_B_4_0: '切换图片',
    C_S_C_B_4_1: '删除图片',
    C_S_C_B_4_2: '直接发送图文',
    C_S_C_B_5: '联系人名片', // WhatsApp APP 渠道功能
    C_S_C_B_5_0: '联系人名片_发送',
    C_S_C_B_6: '艾特成员', // 输入框艾特成员
    C_S_C_B_6_0: '艾特成员_选择成员',
    C_S_C_B_6_1: '艾特成员_输入搜索',
    C_S_C_B_7: '添加表情',
    C_S_C_B_7_0: '添加表情_选择emoji',
    C_S_C_B_7_1: '添加表情_发送贴纸表情',
    C_S_C_B_7_2: '添加表情_新增贴纸表情',
    C_S_C_B_7_3: '添加表情_删除贴纸表情',
    C_S_C_B_8: '发送语音',
    C_S_C_B_8_0: '发送语音_发送',
    C_S_C_B_8_1: '发送语音_取消',
    // 聊天-右侧
    C_R_C: '客户资料',
    C_R_C_0: '重复联系人',
    C_R_C_1: '访客标签',
    C_R_C_2: '加入黑名单',
    C_R_C_3: '关联联系人', // 重复联系人拓展功能
    C_R_C_4: '取消关联联系人', // 重复联系人拓展功能
    C_R_S: '会话信息',
    C_R_S_0: '会话信息_结束会话',
    C_R_S_1: '会话信息_会话标签',
    C_R_S_2: '会话信息_会话备注',
    C_R_S_3: '会话信息_重新分配',
    C_R_F: '话术库',
    C_R_F_0: '话术库_发送', // 采集时机：点击话术库的话术、发送按钮
    C_R_F_1: '话术库_翻译并发送',
    C_R_O: '订单',
    C_R_O_0: '新建订单',
    C_R_O_1: '编辑订单',
    C_R_O_2: '关联订单',
    C_R_H: '跳转查看上下文',
    /* 聊天 end */
};
